import { MicrodistrictType } from "@app/api/microdistrict.api"
import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { api } from '@app/api';
import { RootState } from 'src/store';

export const getAllMicrodistrictsThunk = createAsyncThunk<MicrodistrictType[], void, { state: RootState }>("@@microdistricts/get-all", async (_, { getState }) => {
	const state = getState()
	const areaId = state.geoGuidAreasSlice.area?.id
	if (!areaId) {
		throw new Error("Район не определен")
	}
	return await api.microdistrict.getAll(areaId)
})

export function getAllMicrodistrictsThunkPending(state: RootState["geoGuidMicrodistrictsSlice"]) {
	state.microdistrictsIsLoading = !state.microdistricts.length
}

export function getAllMicrodistrictsThunkRejected(state: RootState["geoGuidMicrodistrictsSlice"]) {
	state.microdistrictsIsLoading = false
}

export function getAllMicrodistrictsThunkFullfilled(state: RootState["geoGuidMicrodistrictsSlice"], { payload }: PayloadAction<MicrodistrictType[]>) {
	state.microdistrictsIsLoading = false
	state.microdistricts = payload
}
